import React from 'react';
import { Router } from '@reach/router';
import Login from 'views/Login';
import SignUp from 'views/SignUp';
import ForgotPassword from 'views/ForgotPassword';
import AccountInfo from 'views/AccountInfo';
import EditAccountInfo from 'views/EditAccountInfo';
import UpgradeAccount from 'views/UpgradeAccount';
import Nav from 'components/Nav';
import NotFound from 'views/NotFound';
import { useSelector } from 'react-redux';
import { AppState } from 'state/store';
import { selectAdminStatus, selectIsUserLoggedIn } from 'state/user/UserSelectors';
import TermsOfUse from 'views/TermsOfUse';
//waveform
import WaveFormCreate from 'views/waveform/WaveFormCreate';
import WaveFormEdit from 'views/waveform/WaveFormEdit';
//sensation
import SensationEdit from 'views/sensation/SensationEdit';
import SensationCreate from 'views/sensation/SensationCreate';
//customer
import CustomerDetail from 'views/customer/CustomerDetail';
import EmailConfirmationSuccess from 'views/EmailConfirmationSuccess';
import AdminDetail from 'views/admin/AdminDetail';
import AdminCreate from 'views/admin/AdminCreate';
//user
import UserList from 'views/UserList';
import { AdminStatus } from 'state/user/UserTypes';
import Unauthorized from 'views/Unauthorized';
import AssetDetail from './views/AssetDetail';
import AssetList from './views/AssetList';
import { AssetTypes } from './state/assets/AssetTypes';

const App: React.FC = (): JSX.Element => {
   //the isAuthenticated hook is designed to make consuming components aware of whether or not the user is authorized to be viewing the page. The function itself returns a boolean which is used in various components to determine whether a loader should be present while the redirect logic within the hook processes. Without this loading state, each view, regardless of whether or not the user is authorized, will flash on page load before the redirect finishes
   const isActiveAdmin: boolean = useSelector((state: AppState) => selectAdminStatus(state) === AdminStatus.active);
   const isUserLoggedIn: boolean = useSelector((state: AppState) => selectIsUserLoggedIn(state));
   return (
      <>
         <Nav isAdmin={isActiveAdmin} isUserLoggedIn={isUserLoggedIn} />
         <Router>
            <Login path="/" />
            <SignUp path="/signup" />
            <ForgotPassword path="/forgot-password" />
            <AccountInfo path="/profile" />
            <EditAccountInfo path="/profile/edit" />
            <UpgradeAccount path="/upgrade" />
            <AssetList path="/waveforms" type={AssetTypes.Waveform} />
            <AssetDetail path="/waveforms/:id" />
            <AssetList path="/sensations" type={AssetTypes.Sensation} />
            <AssetDetail path="/sensations/:id" />
            <WaveFormCreate path="/waveforms/create" />
            <WaveFormEdit path="/waveforms/:id/edit" />
            <SensationCreate path="/sensations/create" />
            <SensationEdit path="/sensations/:id/edit" />
            <UserList path="/customers" role="customer" />
            <CustomerDetail path="/customers/:id" />
            <UserList path="/admins" role="admin" />
            <AdminDetail path="/admins/:id" />
            <AdminCreate path="/admins/create" />
            <EmailConfirmationSuccess path="/email-verified" />
            <TermsOfUse path="/terms" />
            <Unauthorized path="unauthorized" />
            <NotFound default />
         </Router>
      </>
   );
};
export default App;
